<template>
    <div>
        <div v-loading="loading" class="describe-container">
            <zm-form label-position="left" label-width="150px" class="describe-form" v-if="Object.keys(data).length">
                <zm-form-item label="topicUrl">
                    <span v-if="!isCreateTopic">{{ data.topicUrl }}</span>
                    <zm-input v-model="form.topicUrl" v-if="isCreateTopic" style="width: 70%"></zm-input>
                    <zm-button @click="showQuery" type="primary" plain size="small" v-if="!isCreateTopic" style="margin: 0 10px;">Query Task</zm-button>
                    <zm-button @click="deleteTopic" type="danger" plain size="small" v-if="!isCreateTopic && isPage && hasPermission">Delete Topic</zm-button>
                </zm-form-item>
                <zm-form-item label="internal" v-if="!isCreateTopic">
                    {{ data.internal }}
                </zm-form-item>
                <zm-form-item label="partitionNum">
                    <zm-input-number v-if="isCreateTopic" v-model="form.partitionNum" :min="1"></zm-input-number>
                    <span v-if="!isEditPartition && !isCreateTopic">{{ data.partitionNum }}</span>
                    <zm-button type="icon" icon="zm-icon-edit" v-if="!isEditPartition && !isCreateTopic && isPage && hasPermission" @click="isEditPartition = true"></zm-button>
                    <zm-input-number v-model="partition" v-if="isEditPartition && !isCreateTopic" :min="data.partitionNum"></zm-input-number>
                    <zm-button v-if="isEditPartition && !isCreateTopic" type="icon" icon="zm-icon-ok" @click="addPartition" :loading="partitionLoading"
                    :disabled="partition <= data.partitionNum" style="margin-left: 10px;">Save</zm-button>
                    <zm-button v-if="isEditPartition && !isCreateTopic" @click="isEditPartition = false" type="icon" icon="zm-icon-close">Cancel</zm-button>
                </zm-form-item>
                <zm-form-item label="factor">
                    <span v-if="!isCreateTopic">{{ data.factor }}</span>
                    <zm-input-number v-model="form.factor" v-if="isCreateTopic" :min="1"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="configs" class="config-form">
                    <span v-if="!isEditConfig && !isCreateTopic">{{ JSON.stringify(data.configs) }}</span>
                    <zm-button type="icon" icon="zm-icon-edit" v-if="!isEditConfig && !isCreateTopic && isPage && hasPermission" @click="showEditConfig"></zm-button>
                    <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled" v-if="(isEditConfig || isCreateTopic) && !configs.length">add config</zm-button>
                    <zm-table :data="configs" v-if="isEditConfig || isCreateTopic" v-loading="configLoading">
                        <zm-table-column prop="key" label="key">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                                <zm-input size="small" v-model="scope.row.key" v-else></zm-input>
                            </template>
                        </zm-table-column>
                        <zm-table-column prop="value" label="value">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                                <zm-input size="small" v-model.trim="scope.row.value" v-else></zm-input>
                            </template>
                        </zm-table-column>
                        <zm-table-column width="100px">
                            <!-- eslint-disable-next-line -->
                            <template slot="header" slot-scope="scope">
                                <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                            </template>
                            <template slot-scope="scope">
                                <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                                    @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                                <zm-button size="small" type="icon" icon="zm-icon-delete"
                                    @click="deleteParam(scope.row.key)"></zm-button>
                            </template>
                        </zm-table-column>
                    </zm-table>
                    <zm-button v-if="isEditConfig && !isCreateTopic" type="primary" icon="zm-icon-ok" @click="saveConfig" :loading="configLoading">Save</zm-button>
                    <zm-button v-if="isEditConfig && !isCreateTopic" @click="isEditConfig = false">Cancel</zm-button>
                </zm-form-item>
                <zm-form-item>
                    <zm-button v-if="isCreateTopic" type="primary" @click="saveTopic" :loading="loading">Save</zm-button>
                    <zm-button v-if="isCreateTopic" @click="cancelCreateTopic">Cancel</zm-button>
                </zm-form-item>
                <!-- <zm-form-item v-for="(item, index) in data.configs" :key="item" :label="index">
                    {{ item }}
                </zm-form-item> -->
            </zm-form>
            <zm-input size="small" v-model.trim="search" v-if="data.partitions && !isCreateTopic"
                class="search-input" placeholder="input to search"></zm-input>
            <zm-table
                :data="tableData.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)"
                resizable border v-if="data.partitions && !isCreateTopic">
                <zm-table-column prop="partition" label="partition"></zm-table-column>
                <zm-table-column prop="startOffset" label="startOffset"></zm-table-column>
                <zm-table-column prop="endOffset" label="endOffset"></zm-table-column>
                <zm-table-column prop="leader" label="leader">
                    <template slot-scope="scope">
                        <span v-if="scope.row.leader">{{ scope.row.leader.id }}</span>
                    </template>
                </zm-table-column>
                <zm-table-column prop="replicas" label="replicas">
                    <template slot-scope="scope" v-if="scope.row.replicas">
                        <zm-popover v-for="item in scope.row.replicas" :key="item.id"
                            @show="getTopicLogdir(scope.row.partition, item.id)"
                            placement="right-start" style="margin-right: 2px;"
                            trigger="click">
                            <div>
                                <i v-if="loadingLogDir"  class="zm-icon-loading"></i>
                                <span v-else>{{ replicaLogDir }}</span>
                            </div>
                            <zm-tag slot="reference" type="">{{ item.id }}</zm-tag>
                        </zm-popover>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isr" label="isr" :formatter="setIdHost"></zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap" v-if="data.partitions && !isCreateTopic">
                <zm-pagination @size-change="handleSizeChange"
                    :current-page.sync="pageable.pageNumber"
                    :page-size="pageable.pageSize"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="tableData.length">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog title="Query Task" :visible.sync="visible" append-to-body>
            <zm-form label-width="100px">
                <zm-form-item label="partition" prop="partition">
                    <div slot="label">
                        <tip label="partition" id="topicdecribe-query-partition"></tip>
                    </div>
                    <zm-input-number size="small" v-model="queryForm.partition" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="offset" prop="offset">
                    <div slot="label">
                        <tip label="offset" id="topicdecribe-query-offset"></tip>
                    </div>
                    <zm-input-number size="small" v-model="queryForm.offset" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="getTopicTask()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Query Task Result" :visible.sync="resultVisible" append-to-body show-close width="70%">
            <zm-form class="form-inside" label-width="100px">
                <zm-form-item label="handleType" v-if="topicTaskResult.handleType">
                    {{ topicTaskResult.handleType }}
                </zm-form-item>
                <zm-form-item label="payload" v-if="topicTaskResult.payload">
                    <zm-form v-if="typeof topicTaskResult.payload === 'object'" class="body-table-expand">
                        <zm-form-item v-for="item in Object.keys(topicTaskResult.payload)" :key="item" :label="item">
                            {{ topicTaskResult.payload[item] }}
                        </zm-form-item>
                    </zm-form>
                    <span v-else>{{ topicTaskResult.payload }}</span>
                </zm-form-item>
                <zm-form-item label="metadata" v-if="topicTaskResult.metadata">
                    <zm-form class="body-table-expand"
                    v-if="typeof topicTaskResult.metadata === 'object'">
                        <zm-form-item v-for="item in Object.keys(topicTaskResult.metadata)" :key="item" :label="item">
                            {{ topicTaskResult.metadata[item] }}
                        </zm-form-item>
                    </zm-form>
                    <span v-else>{{ topicTaskResult.metadata }}</span>
                </zm-form-item>
                <zm-form-item label="taskContext" v-if="topicTaskResult.taskContext">
                    <zm-form class="body-table-expand"
                    v-if="typeof topicTaskResult.taskContext === 'object'">
                        <zm-form-item v-for="item in Object.keys(topicTaskResult.taskContext)" :key="item" :label="item">
                            {{ topicTaskResult.taskContext[item] }}
                        </zm-form-item>
                    </zm-form>
                    <span v-else>{{ topicTaskResult.taskContext }}</span>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="resultVisible = false">Cancel</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getTopicDescribe, getTopicLogdir, getTopicTask } from '../../api/index'
import { listTopicConfigItems, createTopic, updateTopic, deleteTopic, addPartition } from '../../api/command'
import tip from 'components/ToolTip/index'
export default {
    name: 'topicDescribe',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            isPage: false,
            loading: false,
            data: {},
            isEditPartition: false,
            partition: 0,
            partitionLoading: false,
            isEditConfig: false,
            configs: [],
            configLoading: false,
            search: '',
            replicaLogDir: '',
            loadingLogDir: false,
            visible: false,
            queryForm: {
                offset: 0,
                partition: 0
            },
            form: {
                channelId: '',
                configs: {},
                factor: '',
                topicUrl: '',
                partitionNum: ''
            },
            resultVisible: false,
            topicTaskResult: {},
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    props: ['channelId', 'topicUrl', 'isCreateTopic'],
    created () {
        if (this.$route.name === 'Topic Describe') {
            this.isPage = true
        }
        this.fetchDescribe()
    },
    watch: {
        topicUrl () {
            this.fetchDescribe()
        },
        isCreateTopic () {
            if (this.isCreateTopic) {
                this.showCreateTopic()
            }
        }
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.data.partitions.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.data.partitions
        },
        addDisabled () {
            let data = false
            this.configs.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    methods: {
        showCreateTopic () {
            this.fetchDefaultConfigs()
            this.form.channelId = this.channelId
            this.form.configs = {}
            this.form.factor = 3
            this.form.topicUrl = ''
            this.form.partitionNum = 3
        },
        saveTopic () {
            this.form.configs = {}
            this.configs.map(item => {
                this.form.configs[item.key] = item.value
            })
            this.loading = true
            createTopic(this.form).then(response => {
                this.loading = false
                this.$emit('refresh', response.url)
            }).catch(() => {
                this.loading = false
            })
        },
        cancelCreateTopic () {
            this.$emit('cancelCreateTopic')
        },
        showQuery () {
            this.queryForm.offset = 0
            this.queryForm.partition = 0
            this.visible = true
        },
        getTopicTask () {
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                partition: this.queryForm.partition,
                offset: this.queryForm.offset }
            this.loading = true
            getTopicTask(data).then(response => {
                this.topicTaskResult = response
                this.visible = false
                this.resultVisible = true
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        getTopicLogdir (partition, replicas) {
            this.replicaLogDir = ''
            this.loadingLogDir = true
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                partition: partition,
                brokerId: replicas }
            getTopicLogdir(data).then(response => {
                this.replicaLogDir = response.replicaLogDir
                this.loadingLogDir = false
            }).catch(() => {
                this.loadingLogDir = false
            })
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        setIdHost (row, column, cellValue, index) {
            let string = ''
            if (cellValue) {
                for (let i = 0; i < cellValue.length; i++) {
                    string = string + cellValue[i].id
                    if (i !== cellValue.length - 1) {
                        string += ', '
                    }
                }
            }
            return string
        },
        showEditConfig () {
            this.configs = []
            Object.keys(this.data.configs).map(item => {
                this.configs.push({
                    key: item,
                    value: this.data.configs[item],
                    isEdit: false
                })
            })
            this.isEditConfig = true
        },
        saveConfig () {
            var configs = {}
            this.configs.map(item => {
                configs[item.key] = item.value
            })
            const data = {
                channelId: this.channelId,
                topicUrl: this.topicUrl,
                configs: configs
            }
            this.configLoading = true
            updateTopic(data).then(() => {
                this.isEditConfig = false
                this.fetchDescribe()
                this.configLoading = false
            }).catch(() => {
                this.configLoading = false
            })
        },
        addPartition () {
            this.$confirm('This will add partition. Continue?', 'Warning', {
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                const data = {
                    channelId: this.channelId,
                    topicUrl: this.topicUrl,
                    newPartitionNum: this.partition
                }
                this.partitionLoading = true
                addPartition(data).then(() => {
                    this.partitionLoading = false
                    this.fetchDescribe()
                }).catch(() => {
                    this.partitionLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Add partition canceled'
                })
            })
        },
        fetchDefaultConfigs () {
            listTopicConfigItems().then(response => {
                this.configs = []
                Object.keys(response.configItems).map(item => {
                    this.configs.push({
                        key: item,
                        value: response.configItems[item],
                        isEdit: false
                    })
                })
            })
        },
        deleteTopic () {
            this.$confirm('This will delete the topic. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteTopic(this.channelId, this.topicUrl).then(() => {
                    this.isEditPartition = false
                    this.loading = false
                    this.$emit('refresh')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        addParam () {
            this.configs.unshift({
                key: '',
                value: '',
                isEdit: true
            })
        },
        deleteParam (key) {
            if (key) {
                this.configs.map((item, index, arr) => {
                    if (item.key === key) {
                        this.configs.splice(index, 1)
                    }
                })
            } else {
                this.configs.shift()
            }
        },
        fetchDescribe (selectedTopic) {
            this.loading = true
            // if (selectedTopic) {
            //     this.topicUrl = selectedTopic
            // }
            const topicUrl = selectedTopic || this.topicUrl
            getTopicDescribe(this.channelId, topicUrl).then(response => {
                this.loading = false
                this.data = response
                this.partition = this.data.partitionNum
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style scoped>
.describe-form {
    margin: 10px;
    color: #747487;
    padding-right: 80px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
    padding-right: 80px;
}
.describe-container {
    min-height: 300px;
}
.config-form {
    line-break: anywhere;
    word-break: break-all;
}
</style>
